import { createAsyncThunkActionTypes } from './action-utils';

export const fetchConsent = createAsyncThunkActionTypes('consent/fetchConsent');

export const updateConsents = createAsyncThunkActionTypes('consent/updateConsents');
